export default "/images/3631d84a3d74398498be2fc71060925d.avif";